'use strict';

var page = require('./page'),
	googletaglinchpin = require('int_googletagmanager/googletaglinchpin'),
	global = require('./global');

var pages = {
	account: require('./pages/account'),
	addressbook: require('./pages/addressbook'),
	bookatable: require('./pages/bookatable'),
	contactpreferences: require('./pages/contactpreferences'),
	orderhistory: require('./pages/orderhistory'),
	reminders: require('./pages/reminders'),
	wallet: require('./pages/wallet'),
	wishlist: require('./pages/wishlist'),
	addbillingaddress: require('./pages/addbillingaddress'),
};

var accountInitializer = {
	init: function () {
		global.init();

		$.extend(page, window.pageContext);
		var ns = page.ns;
		if (ns && pages[ns] && pages[ns].init) {
			pages[ns].init();
		}

		if (SitePreferences.GTM_ENABLED && window.pageContext.ns) {
			googletaglinchpin.init(window.pageContext.ns);
		}
	}
};

$(document).ready(function () {
	accountInitializer.init();
});
